// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageBlackBoxUsers-styles___h1--q4mMa {
  text-align: left;
}

.pages-ManageBlackBoxUsers-styles___paper--QjN6v {
  padding: 64px 40px 32px;
  padding-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
}

.pages-ManageBlackBoxUsers-styles___body--ABj_y {
  padding-top: 30px;
  display: flex;
}

.pages-ManageBlackBoxUsers-styles___header--zpccf {
  text-align: left;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pages-ManageBlackBoxUsers-styles___header--zpccf h1 {
    margin: 0;
    font-family: 'Roboto';
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
  }

.pages-ManageBlackBoxUsers-styles___buttonAddUser--fxoWd {
  background: #318afb;
  border: 1px solid #318afb;
  border-radius: 6px;
  font-size: 17px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  height: 52px;
  width: 85px;
}
`, "",{"version":3,"sources":["webpack://./pages/ManageBlackBoxUsers/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AASrB;;AAPE;IACE,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAGF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.paper {\n  padding: 64px 40px 32px;\n  padding-bottom: 0;\n  border-radius: 0;\n  box-shadow: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  background-color: transparent;\n}\n\n.body {\n  padding-top: 30px;\n  display: flex;\n}\n\n.header {\n  text-align: left;\n  padding-top: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  h1 {\n    margin: 0;\n    font-family: 'Roboto';\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n}\n\n.buttonAddUser {\n  background: #318afb;\n  border: 1px solid #318afb;\n  border-radius: 6px;\n  font-size: 17px;\n  color: #ffffff;\n  letter-spacing: 0;\n  text-align: center;\n  height: 52px;\n  width: 85px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageBlackBoxUsers-styles___h1--q4mMa`,
	"paper": `pages-ManageBlackBoxUsers-styles___paper--QjN6v`,
	"body": `pages-ManageBlackBoxUsers-styles___body--ABj_y`,
	"header": `pages-ManageBlackBoxUsers-styles___header--zpccf`,
	"buttonAddUser": `pages-ManageBlackBoxUsers-styles___buttonAddUser--fxoWd`
};
module.exports = ___CSS_LOADER_EXPORT___;
